var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "155px",
    width: "155px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD54"
    },
    d: "M512,256.006C512,397.402,397.394,512.004,256.004,512C114.606,512.004,0,397.402,0,256.006 C-0.007,114.61,114.606,0,256.004,0C397.394,0,512,114.614,512,256.006z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4BA41"
    },
    d: "M455.728,416.071c-0.439-0.449-69.229-69.327-69.804-69.804c-0.546-0.518-1.019-1.117-1.595-1.597 c-0.544-0.515-225.559-225.652-226.143-226.135c-5.769-5.441-13.196-8.866-21.211-9.367c-9.814-0.477-19.365,3.035-26.297,9.974 l-28.191,28.258c-15.659,15.69-38.331,65.957,88.983,193.535c0.256,0.256,0.494,0.478,0.75,0.733c0.29,0.291,0.55,0.567,0.843,0.86 c0.256,0.256,157.358,157.358,157.649,157.65c0.194,0.194,0.38,0.371,0.569,0.556C380.883,485.498,424.027,455.578,455.728,416.071 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4BA41"
    },
    d: "M502.096,185.529c-0.347-0.35-0.691-0.701-1.043-1.044c-0.527-0.542-85.456-85.469-85.991-85.993 c-16.858-17.27-40.347-28.039-66.333-28.039c-51.158,0-92.773,41.615-92.773,92.773c0,25.984,10.768,49.471,28.037,66.33 c0.526,0.538,176.22,176.234,176.754,176.754c0.47,0.482,0.945,0.956,1.425,1.424C493.473,365.273,512,312.813,512,256.005 C512,231.551,508.499,207.927,502.096,185.529z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F6F6"
    },
    d: "M389.664,350.645l-44.129-34.435c-12.473-9.709-29.822-9.642-42.204,0.159l-9.807,7.769 c-7.444,5.882-18.119,5.262-24.839-1.45l-78.949-79.116c-6.719-6.742-7.339-17.463-1.45-24.938l7.754-9.838 c9.777-12.389,9.838-29.762,0.159-42.242l-34.359-44.227c-6.017-7.754-15.077-12.548-24.862-13.159 c-9.814-0.476-19.365,3.035-26.297,9.973l-28.192,28.259c-15.659,15.689-38.331,65.956,88.983,193.535 c82.959,83.148,133.588,100.603,161.455,100.61h0.007c16.783,0,26.508-6.213,31.717-11.43l28.191-28.252 c6.924-6.939,10.547-16.534,9.936-26.326C402.175,365.745,397.395,356.671,389.664,350.645z M381.896,390.947l-28.191,28.252 c-3.133,3.14-9.286,6.885-20.77,6.885h-0.007c-20.415-0.007-67.119-12.487-150.508-96.065 c-96.073-96.276-107.979-152.667-88.984-171.7l28.191-28.259c3.518-3.525,8.283-5.489,13.228-5.489c0.385,0,0.77,0.007,1.163,0.03 c5.353,0.34,10.314,2.96,13.605,7.211l34.359,44.227c5.315,6.848,5.278,16.383-0.083,23.186l-7.754,9.838 c-10.736,13.62-9.603,33.145,2.642,45.428l78.949,79.123c12.261,12.276,31.77,13.409,45.382,2.65l9.814-7.769 c6.772-5.376,16.262-5.406,23.088-0.091l44.129,34.428c4.243,3.307,6.863,8.29,7.195,13.665 C387.686,381.872,385.693,387.135,381.896,390.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F6F6"
    },
    d: "M348.729,70.453c-51.158,0-92.773,41.615-92.773,92.773S297.57,256,348.729,256 s92.773-41.615,92.773-92.773S399.887,70.453,348.729,70.453z M348.729,240.538c-42.627,0-77.311-34.685-77.311-77.311 s34.685-77.311,77.311-77.311s77.311,34.685,77.311,77.311S391.356,240.538,348.729,240.538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F6F6"
    },
    d: "M381.088,127.818l-38.919,54.624l-19.063-17.969c-3.095-2.937-8.003-2.786-10.925,0.324 c-2.929,3.103-2.786,7.996,0.324,10.925l25.511,24.054c1.435,1.359,3.338,2.107,5.3,2.107c0.25,0,0.506-0.015,0.755-0.037 c2.227-0.219,4.243-1.389,5.541-3.209l44.069-61.849c2.477-3.473,1.668-8.305-1.812-10.781 C388.388,123.53,383.564,124.33,381.088,127.818z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.bee4da1d6436f2566925080a4def2c59.svg";
export { ForwardRef as ReactComponent };